import React, { ReactNode, useEffect } from "react";
import { cn } from "@/libs/utils";
import { SUPPORT_SLIDE_ZINDEX } from "@/v2-components/pages/support/constants/support-slide-constants";

interface SupportAccordionSlideProps {
  isOpen: boolean;
  setIsOpen: () => void;
  fixedContent: ReactNode;
  slideContent: ReactNode;
  slideZIndex?: number;
  className?: string;
}

export const SupportAccordionSlide = ({
  isOpen,
  setIsOpen,
  fixedContent, // 고정된 영역의 콘텐츠
  slideContent, // 슬라이드될 영역의 콘텐츠
  className,
}: SupportAccordionSlideProps) => {
  // isOpen 시  스크롤 잠금
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // 스크롤 잠금
    } else {
      document.body.style.overflow = "auto"; // 스크롤 복원
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    <article
      className={cn("relative z-30 block h-14 text-base smd:hidden", className)}
    >
      {/* dim section */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-coolgray-100 bg-opacity-50"
          onClick={setIsOpen}
        />
      )}

      {/* fixed section */}
      <div
        className={cn(
          "relative w-full cursor-pointer",
          SUPPORT_SLIDE_ZINDEX["header"],
        )}
      >
        {fixedContent}
      </div>

      {/* slide section */}
      <div
        className={cn(
          "absolute left-0 w-full rounded-b-2xl bg-white transition-transform duration-300 ease-in-out",
          isOpen ? `translate-y-0` : "-translate-y-full",
          SUPPORT_SLIDE_ZINDEX["slide"],
        )}
        style={{
          transformOrigin: "top", // 슬라이드 애니메이션의 시작 위치 설정
          top: "100%", // 고정된 영역 바로 아래에 위치
          height: "70vh",
        }}
      >
        <div className="max-h-full overflow-y-auto p-4">
          <div className="truncate">{slideContent}</div>
        </div>
      </div>
    </article>
  );
};
